import React, { useEffect, useState } from "react";
import Select from "react-select";

import "./ModuleAccess.scss";
import { useDispatch, useSelector } from "react-redux";

import "./ModuleAccess.scss";
import {
  getAllModuleAccess,
  getModuleRoleStatus,
  moduleAccessUpdate,
} from "./moduleAccessService";
import {
  ModuleDownArrow,
  ModuleRightArrow,
} from "../../../../assets/images/svg/svg";
import { RenderPage } from "../../../../slices/common/reducer";
import {
  checkedFalse,
  checkedTrue,
} from "../../../../slices/moduleAccess/checkedDataSlice";
import { getAllRoles, getRoles } from "../Users/UserService";
import {
  checkAccessPermission,
  getEntityType,
  getOrgId,
} from "../../../../Utils/CommonUtils";
import CommonHeader from "../../../../Components/Common/CommonHeader/CommonHeader";
import { sidebarList } from "../../../../Utils/CommonService";
import { getRoleList } from "../Roles/RolesService";
import { useParams } from "react-router-dom";
import CommonButton from "../../../../Components/Common/CommonButton/CommonButton";

const ViewAction = "VIEW";

const InputField = ({
  item,
  menuitem,
  isParent,
  setIsParent,
  parentList,
  setParentList,
  parentData,
  action,
}) => {
  const findData = useSelector((state) => state.findData);
  const getIsExistData = (module_id, role_id, action) => {
    return findData.find(
      (item) =>
        item?.module_id === module_id &&
        item?.role_id === role_id &&
        item?.action_type === action
    );
  };

  const dispatch = useDispatch();
  const getFilteredArray = (childFilterData) => {
    const uniqueCombinations = new Set();
    const filteredArray = [];
    function createKey(obj) {
      return Object.keys(obj)
        .map((key) => `${key}:${obj[key]}`)
        .join("|");
    }
    for (const obj of childFilterData) {
      const combinationKey = createKey(obj);
      if (!uniqueCombinations.has(combinationKey)) {
        uniqueCombinations.add(combinationKey);
        filteredArray.push(obj);
      }
    }
    return filteredArray;
  };
  let handleClick = (id, name, clickedAction, e) => {
    // if (!checkAccessPermission("EDIT", "SETT_UMT_MAS")) {
    //   return false;
    // }
    if (clickedAction !== ViewAction) {
      console.log("Hii");
      if (
        !isParent.some(
          (item) =>
            item.module_id === id &&
            item.role_id === name &&
            item.action_type === ViewAction
        )
      ) {
        return;
      }
    }
    if (
      !isParent.some(
        (item) =>
          item.module_id === id &&
          item.role_id === name &&
          item.action_type === action
      )
    ) {
      const isExist = getIsExistData(id, name, action);
      dispatch(
        checkedTrue({
          ...isExist,
          module_id: id,
          role_id: name,
          action_type: action,
        })
      );
      setIsParent([
        ...isParent,
        { module_id: id, role_id: name, action_type: action },
      ]);

      let arr = [];
      arr.push({ id: item.id, name: menuitem?.value });
      let loop = (it) => {
        if (it.menus) {
          it.menus.map((child) => {
            if (
              isParent.some(
                (boxItem) =>
                  boxItem.module_id === child.id &&
                  boxItem.role_id === name &&
                  boxItem.action_type === action
              )
            ) {
              arr.push({ id: child.id, name: menuitem?.value });
              loop(child);
            }
          });
        }
      };
      loop(item);
      setParentList([...parentList, ...arr]);
    } else {
      const isExist = getIsExistData(id, name, action);
      dispatch(
        checkedFalse({
          ...isExist,
          module_id: id,
          role_id: name,
          action_type: action,
        })
      );
      const data = isParent.filter((filterItem) => {
        return (
          filterItem.module_id !== id ||
          filterItem.role_id !== name ||
          filterItem.action_type !== action
        );
      });

      setIsParent(data);

      if (action !== ViewAction) {
        return;
      }

      let parentListIdfilter = new Set();
      let childFilterData = new Array();
      parentListIdfilter.add({ id: id, name: menuitem.value });

      let loop = (it) => {
        if (!it.menus) {
          const filterData = isParent.filter(
            (parent) => parent.module_id === it.id && parent.role_id === name
          );
          if (filterData !== undefined) {
            childFilterData.push(...filterData);
          }
          const id = parentList.filter(
            (iteme) => iteme.id === it.id && iteme.name === menuitem.value
          );

          if (id !== undefined) {
            parentListIdfilter.add(...id);
          }
          return;
        }
        if (it.menus) {
          it.menus.map((child) => {
            const filterData = isParent.filter(
              (parent) => parent.module_id === it.id && parent.role_id === name
            );
            if (filterData !== undefined) {
              childFilterData.push(...filterData);
            }
            const id = parentList.filter(
              (iteme) => iteme.id === it.id && iteme.name === menuitem.value
            );

            if (id !== undefined) {
              parentListIdfilter.add(...id);
            }
            loop(child);
          });
        }
      };

      loop(item);
      let updateChildfilter = new Array();
      updateChildfilter = getFilteredArray(childFilterData);

      updateChildfilter.map((item) => {
        let getExist = getIsExistData(
          item.module_id,
          item.role_id,
          item.action_type
        );
        return dispatch(
          checkedFalse({
            ...getExist,
            module_id: item.module_id,
            role_id: item.role_id,
            action_type: item.action_type,
          })
        );
      });
      const childFilterArr = new Set();

      updateChildfilter.forEach((item) => {
        if (item !== undefined) {
          if (
            !isParent.some(
              (parentItem) =>
                parentItem.module_id === item.module_id &&
                parentItem.role_id === item.role_id &&
                parentItem.action_type === item.action_type
            )
          ) {
            childFilterArr.add(item);
          }
        }
      });

      const childnewArray = Array.from(updateChildfilter);
      isParent.forEach((item) => {
        if (
          !childnewArray.some(
            (itemer) =>
              itemer?.module_id === item.module_id &&
              itemer?.role_id === item.role_id &&
              itemer?.action_type === item.action_type
          )
        ) {
          childFilterArr.add(item);
        }
      });

      setIsParent([...childFilterArr]);
      const filterArr = new Set();

      parentListIdfilter.forEach((item) => {
        if (item !== undefined) {
          if (
            !parentList.some(
              (parentItem) =>
                parentItem.id === item.id && parentItem.name === item.name
            )
          ) {
            filterArr.add(item);
          }
        }
      });

      const newArray = Array.from(parentListIdfilter);
      parentList.forEach((item) => {
        if (
          !newArray.some(
            (itemer) => itemer?.id === item.id && itemer?.name === item.name
          )
        ) {
          filterArr.add(item);
        }
      });

      setParentList([...filterArr]);
    }
  };
  return (
    <>
      {action === ViewAction ? (
        <td
          style={{ textAlign: "center" }}
          className="checkbox-custom-container d-flex justify-content-center"
        >
          <label key={menuitem.value} className="custom-checkbox">
            <input
              className="filled-in"
              id="filled-in-box"
              type="checkbox"
              onChange={(e) =>
                handleClick(item.id, menuitem.role_id, item.action, e)
              }
              checked={isParent.some(
                (boxItem) =>
                  boxItem.module_id === item.id &&
                  boxItem.role_id === menuitem.role_id &&
                  boxItem.action_type === action
              )}
              disabled={
                !parentList.some(
                  (val) =>
                    val.id === parentData &&
                    (val.name === menuitem.value || val.name === "")
                )
              }
            />
            <span className="checkmark"></span>
          </label>
        </td>
      ) : isParent.some(
          (boxItem) =>
            boxItem.module_id === item.id &&
            boxItem.role_id === menuitem.role_id &&
            boxItem.action_type === ViewAction
        ) ? (
        <td className="checkbox-custom-container d-flex justify-content-center">
          <label key={menuitem.value} className="custom-checkbox">
            <input
              type="checkbox"
              className="filled-in"
              id="filled-in-box"
              onChange={() =>
                handleClick(item.id, menuitem.role_id, item.action)
              }
              checked={isParent.some(
                (boxItem) =>
                  boxItem.module_id === item.id &&
                  boxItem.role_id === menuitem.role_id &&
                  boxItem.action_type === action
              )}
              disabled={
                !parentList.some(
                  (val) =>
                    val.id === parentData &&
                    (val.name === menuitem.value || val.name === "")
                )
              }
            />
            <span className="checkmark"></span>
          </label>
        </td>
      ) : (
        <td
          style={{ textAlign: "center" }}
          className="checkbox-custom-container d-flex justify-content-center"
        >
          <label key={menuitem.value} className="custom-checkbox">
            <input
              type="checkbox"
              className="filled-in"
              id="filled-in-box"
              checked={isParent.some(
                (boxItem) =>
                  boxItem.module_id === item.id &&
                  boxItem.role_id === menuitem.role_id &&
                  boxItem.action_type === action
              )}
              disabled={true}
            />
            <span className="checkmark"></span>
          </label>
        </td>
      )}
    </>
  );
};

const RecursiveRow = ({
  item,
  level,
  isParent,
  setIsParent,
  parentData,
  parentList,
  setParentList,
  selectedOption,
}) => {
  const [display, setDisplay] = useState(false);
  const handleToggle = () => {
    setDisplay(!display);
  };

  const contentStyle = {
    paddingLeft: level * 30 + "px",
    display: "table-cell",
    userSelect: "none",
    textAlign: "start",
  };

  const withoutArrowcontentStyle = {
    paddingLeft: level * 55 + "px",
    display: "table-cell",
    userSelect: "none",
    textAlign: "start",
  };

  return (
    <>
      <tr>
        <td
          onClick={handleToggle}
          style={item.menus ? contentStyle : withoutArrowcontentStyle}
          className="menu-th"
        >
          {item.menus && (
            <span style={{ marginRight: "5px" }}>
              {display ? <ModuleDownArrow /> : <ModuleRightArrow />}
            </span>
          )}
          {item.action === ViewAction || item.action === "View"
            ? item.name
            : ""}
        </td>
        <td style={{ textAlign: "center" }} className="action-th">
          {item?.action?.slice(0, 1)?.toUpperCase() +
            item?.action?.slice(1)?.toLowerCase()}
        </td>
        {selectedOption?.map((menuitem) => (
          <td>
            <InputField
              item={item}
              menuitem={menuitem}
              isParent={isParent}
              setIsParent={setIsParent}
              parentList={parentList}
              setParentList={setParentList}
              parentData={parentData}
              action={item.action}
            />
          </td>
        ))}
      </tr>
      {item.menus &&
        display &&
        item.menus.map((child) => (
          <RecursiveRow
            key={child.id}
            item={child}
            level={level + 1}
            isParent={isParent}
            setIsParent={setIsParent}
            parentData={item.id}
            parentList={parentList}
            setParentList={setParentList}
            selectedOption={selectedOption}
          />
        ))}
    </>
  );
};

const ModuleAccess = () => {
  let data = useSelector((state) => state.moduleAccess);
  const rolesData = useSelector((state) => state.roles.rolesData);
  const triggerRender = useSelector((state) => state.common.triggerRender);
  const organizationid = useSelector((state) => state.roles.organizationid);

  const [options, setOptions] = useState([]);
  const finalData = useSelector((state) => state.moduleAccess);
  const [isParent, setIsParent] = useState([]);
  const [parentList, setParentList] = useState([{ id: -1, name: "" }]);
  const [selectedOption, setSelectedOption] = useState([]);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const listOptions = [{ value: "All", label: "All" }];

  // const entityType = localStorage.getItem("entityType");
  // const organizationId = localStorage.getItem("organizationId");

  const organizationId = selectedUser.organizationid;
  const entityType = selectedUser.entitytype;

  finalData.map((item) =>
    listOptions.push({ value: item?.menu, label: item?.menu })
  );

  const handleSelectChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    getModuleRoleStatus(setIsParent, setParentList);
  };

  const updatedData = useSelector((state) => state.checkedData);

  const dispatch = useDispatch();
  const moduleUpdate = () => {
    moduleAccessUpdate(updatedData);
    sidebarList(organizationId);
    dispatch(RenderPage());
  };

  useEffect(() => {
    if (rolesData) {
      const newOptions = rolesData.map((option) => ({
        role_id: option.entityid,
        label: option.name,
        value: option.code,
      }));

      setOptions(newOptions);
    }
  }, [rolesData]);

  useEffect(() => {
    setSelectedOption(options.slice(0, 4));
  }, [options]);

  const id = useParams();

  useEffect(() => {
    getRoleList(organizationId, entityType);
  }, [organizationId, entityType]);

  useEffect(() => {
    // console.log(data)
    getAllModuleAccess(organizationId);
    getModuleRoleStatus(setIsParent, setParentList);
  }, [organizationId, triggerRender]);

  return (
    <div className="treelist-content-list">
      {/* <CommonHeader update={true} apiUpdate={moduleUpdate} /> */}
      <div className="treelist-select">
        <Select
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              borderColor: state.isFocused ? "#29badb" : "#29badb !important",
            }),
          }}
          theme={(theme) => ({
            ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
              // borderColor: state.isFocused ? "#C7222A" : "#C7222A !important",
              primary: "#29badb",
            },
          })}
          options={options}
          value={selectedOption}
          onChange={handleSelectChange}
          isMulti={true}
        />
      </div>

      <div className="table-main-conatiner">
        <div className="table-scroll-sub-container">
          <table>
            <thead>
              <tr className="table-th-tr">
                <th rowSpan={3} style={{ width: "300px" }} className="menu-th">
                  MENU
                </th>
                <th
                  rowSpan={3}
                  style={{ width: "200px" }}
                  className="action-th"
                >
                  ACTION
                </th>
                <th
                  rowSpan={1}
                  colSpan={selectedOption.length}
                  style={{ padding: "15px" }}
                  className="roles-th"
                >
                  <div className="roles-container">ROLES</div>
                </th>
              </tr>
              <tr className="table-th-tr">
                {selectedOption?.map((item) => (
                  <th className="roles-th">{item?.label?.toUpperCase()}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.map((parent) => (
                <RecursiveRow
                  key={parent.id}
                  item={parent}
                  level={0}
                  isParent={isParent}
                  setIsParent={setIsParent}
                  parentData={-1}
                  parentList={parentList}
                  setParentList={setParentList}
                  selectedOption={selectedOption}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <CommonButton save={true} handleSubmit={moduleUpdate}/>
    </div>
  );
};

export default ModuleAccess;
